export class ReturnStruct {
  isError: boolean;
  errorCode: number;
  errorDescription: string;
}
